import { render, staticRenderFns } from "./PopupRequest.vue?vue&type=template&id=dd9709bc"
import script from "./PopupRequest.vue?vue&type=script&lang=js"
export * from "./PopupRequest.vue?vue&type=script&lang=js"
import style0 from "./PopupRequest.vue?vue&type=style&index=0&id=dd9709bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports